import React from "react";
import { useState } from "react";

export function encode(data: any) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export const Contact = () => {
  const [formState, setFormState] = useState({ email: "test@test.com" });
  const handleChange = (e: any) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    try {
      await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "send-a-message",
          ...formState,
          "text-to-send": "This is a test text.",
        }),
      });
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div style={{ display: "none" }}>
      <input
        type="email"
        name="email"
        placeholder="enter your email"
        defaultValue="test@test.com"
        onChange={handleChange}
      />
      <button onClick={handleSubmit}>send</button>
    </div>
  );
};
